import posthog from 'posthog-js';

const DEFAULT_POSTHOG_HOST = 'https://app.posthog.com';
const COMPONENT_CRASH_EVENT = 'component_crash_white_screen';

let hasInitialized = false;

function canUsePostHog() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

function readPostHogConfig() {
  const apiKey = process.env.RAZZLE_POSTHOG_KEY;

  return {
    apiKey,
  };
}

export function initPostHog() {
  if (!canUsePostHog() || hasInitialized) {
    return;
  }

  const { apiKey } = readPostHogConfig();
  if (!apiKey) {
    console.warn('PostHog not initialized: missing API key');
    return;
  }

  posthog.init(apiKey, {
    api_host: "https://us.posthog.com",
    capture_pageview: false,
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
  });

  hasInitialized = true;
}

function readSessionId() {
  if (typeof window === 'undefined') {
    return process.env.PROJECT_ID || '';
  }

  return (
    window.localStorage.getItem('cms_session_id') ||
    window.localStorage.getItem('session_id') ||
    process.env.PROJECT_ID ||
    ''
  ).trim();
}

function readPagePath() {
  if (typeof window === 'undefined') {
    return '';
  }

  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function captureComponentCrash(error: unknown) {
  const { apiKey } = readPostHogConfig();
  if (!apiKey) {
    return;
  }

  const errorMsg =
    error instanceof Error
      ? error.message || error.toString()
      : typeof error === 'string'
        ? error
        : 'Unknown component crash';

  posthog.capture(COMPONENT_CRASH_EVENT, {
    error_msg: errorMsg,
    page_path: readPagePath(),
    session_id: readSessionId(),
  });
}
